import { FC } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useTrans } from '@libs/i18n';

import {
  type HubDisplayStatus,
  STATUS_META,
  TONE_SX,
} from './documentStatusMeta';

interface Props {
  status: HubDisplayStatus;
}

/** Small colored status pill (a leading dot + label) used in the table. */
export const DocumentStatusPill: FC<Props> = observer(({ status }) => {
  const { t } = useTrans();
  const meta = STATUS_META[status];
  const tone = TONE_SX[meta.tone];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.625,
        typography: 'textXS_semiBold',
        color: tone.fg,
        backgroundColor: tone.bg,
        border: 1,
        borderColor: tone.border,
        borderRadius: 999,
        px: 1,
        py: '3px',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="span"
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          flex: 'none',
          backgroundColor: tone.fg,
        }}
      />
      {t(meta.labelKey)}
    </Box>
  );
});
